/* BLENIN card videos (2026-10-02)
   Product cards with a video (snippets/product-block.liquid renders .bl-card-video with data-src) play it muted in a loop:
   - desktop (real hover): on hover only;
   - touch screens: while the card is mostly on screen, at most 2 at a time.
   Nothing is downloaded until a video is about to play. Off with prefers-reduced-motion or Save-Data. */
(function () {
  if (window.__blCardVideo) return;
  window.__blCardVideo = true;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  if (reduce || saveData) return;

  var canHover = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  var MAX_PLAYING = 2;
  var playing = [];

  var style = document.createElement('style');
  style.textContent =
    '.bl-card-video{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;transition:opacity .35s ease;pointer-events:none;overflow:hidden}' +
    '.bl-card-video video{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;display:block}' +
    '.bl-card-video.is-on{opacity:1}';
  document.head.appendChild(style);

  function video(wrap) { return wrap.querySelector('video'); }

  function play(wrap) {
    if (wrap.dataset.blOff === '1') return;
    var v = video(wrap);
    if (!v) return;
    var src = canHover ? (wrap.dataset.srcLg || wrap.dataset.src) : (wrap.dataset.src || wrap.dataset.srcLg);
    if (!v.getAttribute('src') && src) v.setAttribute('src', src);
    v.muted = true;
    if (!v.dataset.blListen) {
      v.dataset.blListen = '1';
      v.addEventListener('playing', function () { if (wrap.dataset.blWant === '1') wrap.classList.add('is-on'); });
    }
    wrap.dataset.blWant = '1';
    var p = v.play();
    if (p && p.catch) p.catch(function () { wrap.classList.remove('is-on'); });
    if (playing.indexOf(wrap) < 0) playing.push(wrap);
    while (playing.length > MAX_PLAYING) stop(playing[0]);
  }

  function stop(wrap) {
    wrap.dataset.blWant = '0';
    wrap.classList.remove('is-on');
    var v = video(wrap);
    if (v && !v.paused) v.pause();
    var i = playing.indexOf(wrap);
    if (i >= 0) playing.splice(i, 1);
  }

  var io = !canHover && 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting && e.intersectionRatio >= 0.6) play(e.target);
      else stop(e.target);
    });
  }, { threshold: [0, 0.6] }) : null;

  function bind(wrap) {
    if (wrap.dataset.blBound) return;
    wrap.dataset.blBound = '1';
    var card = wrap.closest('product-block') || wrap.closest('.product-block') || wrap.parentNode;
    if (canHover) {
      card.addEventListener('mouseenter', function () { play(wrap); });
      card.addEventListener('mouseleave', function () { stop(wrap); });
    } else if (io) {
      io.observe(wrap);
      // the shopper swipes to another photo on the card: stop the video on that card for good
      card.addEventListener('touchmove', function () { wrap.dataset.blOff = '1'; stop(wrap); }, { passive: true });
    }
  }

  function scan(root) {
    (root.querySelectorAll ? root : document).querySelectorAll('.bl-card-video').forEach(bind);
  }

  function start() {
    scan(document);
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.classList.contains('bl-card-video')) bind(n); else scan(n); } });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) playing.slice().forEach(stop);
      else if (io) document.querySelectorAll('.bl-card-video[data-bl-bound]').forEach(function (w) { io.unobserve(w); io.observe(w); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
